export default __webpack_public_path__ + "static/media/green-ball-inverted.73c86936.svg";